<template>
    <div class="nav-wrapper">
        <img class="nav-img-logo" :src="decodeURI(logoUrl)" alt="">
        <p class="nav-app-name">{{name}}</p>

         <div id="nav-coin" class="nav-coins">
         <img class="nav-coin-logo" src="../assets/gem.svg" />
            {{totalCoins}}
        </div>
    </div>
</template>

<script>
export default {
     props:['totalCoins','name','logoUrl'],
   
     mounted(){
         if(this.totalCoins == 0) document.getElementById('nav-coin').style.display = 'none';
         

     }
}
</script>